import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { PullIndicator, usePullToRefresh } from 'gunsi-auth'
import { TopBar } from '../components/TopBar.jsx'
import { BottomNav } from '../components/BottomNav.jsx'
import { TallyProvider, useTally } from '../hooks/useTally.jsx'

export function Dashboard() {
  // Slot under the topbar that pages may fill via portal (e.g. Transactions'
  // sticky head). Empty by default — `.sub-topbar:empty` collapses it.
  const [subTopbar, setSubTopbar] = useState(null)

  return (
    <TallyProvider>
      <div className="app-shell">
        <TopBar />
        <div className="sub-topbar" ref={setSubTopbar} />
        <Content subTopbar={subTopbar} />
        <BottomNav />
      </div>
    </TallyProvider>
  )
}

// Dentro il provider: il pull-to-refresh agisce sul contenitore che scorre,
// quindi vale per tutte le viste (movimenti, statistiche, categorie…).
function Content({ subTopbar }) {
  const { refreshAll } = useTally()
  const { listRef, pull, refreshing, ready } = usePullToRefresh(refreshAll)

  return (
    <div className="ptr-wrap app-scroll">
      <PullIndicator pull={pull} refreshing={refreshing} ready={ready} />
      <div
        className="app-content"
        ref={listRef}
        style={{
          transform: pull ? `translateY(${pull}px)` : undefined,
          transition: pull ? undefined : 'transform 180ms ease-out',
        }}
      >
        <Outlet context={{ subTopbar }} />
      </div>
    </div>
  )
}
